import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Provider } from 'mobx-react'
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
import App from './containers/App'
import UserProfile from './containers/UserProfile'
import TeamProfile from './containers/TeamProfile'
import PlanPage from './containers/PlanPage'
import IdeaList from './containers/IdeaList'
import IdeaStorage from './containers/IdeaStorage'
import Login from './containers/Login'
import ForgotPassword from './containers/ForgotPassword'
import Signup from './containers/Signup'
import IdeaStore from './stores/IdeaStore'
import AuthStore from './stores/AuthStore'
import ToolStore from './stores/ToolStore'
import NotificationStore from './stores/NotificationStore'
import MessageStore from './stores/MessageStore'
import PrefStore from './stores/PrefStore'
import TeamStore from './stores/TeamStore'
import Logger from './stores/Logger'
import IdeaPage from './containers/IdeaPage'
import PresentIdea from './containers/PresentIdea'
import PresentIdeaOptions from './containers/PresentIdeaOptions'
import Goodbye from './containers/Goodbye'
import ViewIdeaPage from './containers/ViewIdeaPage'
import NotFound from './containers/NotFound'
import Error from './containers/Error'
import Forbidden from './containers/Forbidden'
import EnsureLoggedInContainer from './containers/EnsureLoggedInContainer'
import './index.css'

if(window.location.host==='tool.pre.do'){
  ReactGA.initialize('UA-88451894-3') // tool.pre.do
  // console.log('GA property tool.pre.do')
  if(window.Bugsnag)
    window.Bugsnag.releaseStage = "production"
}else{
  ReactGA.initialize('UA-88451894-4') // dev.pre.do
  // console.log('GA property dev.pre.do')
  if(window.Bugsnag)
    window.Bugsnag.releaseStage = "development"
}

const aStore =  new AuthStore()
const prefStore = new PrefStore(aStore)
const routingStore = new RouterStore()
const toolStore = new ToolStore(aStore)
const notificationStore = new NotificationStore(aStore)
const messageStore = new MessageStore(aStore, notificationStore)
const teamStore = new TeamStore(aStore, notificationStore)
const stores = {
    authStore: aStore,
    routingStore: routingStore,
    toolStore: toolStore,
    notificationStore: notificationStore,
    messageStore: messageStore,
    prefStore: prefStore,
    teamStore: teamStore,
    store: new IdeaStore(aStore, toolStore, notificationStore, prefStore),
    logger: new Logger(aStore),
}
const history = syncHistoryWithStore(browserHistory, routingStore)

ReactDOM.render(
  <Provider stores={stores}>
      <Router history={history} onUpdate={stores.logger.logPageView}>
          <Route path='/' component={App}>
            <Route path='/login' component={Login}/>
            <Route path='/signup' component={Signup}/>
            <Route path='/forgot' component={ForgotPassword}/>
            <Route path='/goodbye' component={Goodbye}/>
            <Route component={EnsureLoggedInContainer}>
              <IndexRoute component={IdeaList} />
              <Route path='/profile' component={UserProfile}/>
              <Route path='/team' component={TeamProfile}/>
              <Route path='/idea-storage' component={IdeaStorage}/>
              <Route path='/idea/:ideaKey' component={IdeaPage}/>
              <Route path='/idea/:ideaKey/presentation-options' component={PresentIdeaOptions}/>
              <Route path='/idea/:ideaKey/view' component={ViewIdeaPage}/>
              <Route path='/idea/:ideaKey/edit' component={IdeaPage}/>
              <Route path='/plans' component={PlanPage}/>
              <Route path='/ideas' component={IdeaList}/>
              <Route path='/viewIdea/:ideaKey' component={ViewIdeaPage}/> 
              <Route path='/present/:ideaKey' component={PresentIdea}/>
            </Route>
            <Route path='/forbidden' component={Forbidden} />
            <Route path='/notfound' component={NotFound} />
            <Route path='/error' component={Error} />
            <Route path='*' component={NotFound} />
          </Route>
      </Router>
  </Provider>,
  document.getElementById('root'),
)



// WEBPACK FOOTER //
// ./src/index.js